import { Head, useForm } from '@inertiajs/react'

interface Props {
  errors?: Record<string, string | string[]>
}

export default function SuperAdminSignIn({ errors = {} }: Props) {
  const { data, setData, post, processing } = useForm({
    super_admin: { email: '', password: '', remember_me: false }
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    post('/super_admin/sign_in')
  }

  const baseError = errors.base
  const baseErrorText = Array.isArray(baseError) ? baseError[0] : baseError

  return (
    <>
      <Head title="SuperAdmin Sign In · Pinnacle" />
      <div className="min-h-screen bg-[#351E1D] flex items-center justify-center p-6">
        <div className="max-w-md w-full">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-white">Pinnacle SuperAdmin</h1>
            <p className="text-sm text-text-on-dark mt-2">Cross-tenant administration. Tenant users sign in elsewhere.</p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-8">
            {baseErrorText && (
              <div className="mb-4 px-3 py-2 bg-red-50 text-red-700 text-sm rounded">{baseErrorText}</div>
            )}
            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label className="block text-sm font-medium text-text-primary mb-1">Email</label>
                <input
                  type="email"
                  required
                  autoFocus
                  value={data.super_admin.email}
                  onChange={e => setData('super_admin', { ...data.super_admin, email: e.target.value })}
                  className="w-full px-4 py-2.5 border border-stone/30 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#ED1C24]/20 focus:border-[#ED1C24]"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-text-primary mb-1">Password</label>
                <input
                  type="password"
                  required
                  value={data.super_admin.password}
                  onChange={e => setData('super_admin', { ...data.super_admin, password: e.target.value })}
                  className="w-full px-4 py-2.5 border border-stone/30 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#ED1C24]/20 focus:border-[#ED1C24]"
                />
              </div>

              <button
                type="submit"
                disabled={processing}
                className="w-full px-4 py-2.5 bg-[#ED1C24] text-white rounded-lg font-semibold hover:bg-[#C7161E] disabled:opacity-50"
              >
                {processing ? 'Signing in…' : 'Sign in'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}
